import React from "react";
import TextField from "./ApplicationView/TextField";
import Hidden from "./ApplicationView/Hidden";
import Checkbox from "./ApplicationView/Checkbox";
import Radio from "./ApplicationView/Radio";
import TextArea from "./ApplicationView/TextArea";
import Select from "./ApplicationView/Select";
import TextTable from "./ApplicationView/TextTable";
import Location from "./ApplicationView/Location";
import EmailField from "./ApplicationView/EmailField";
import PasswordField from "./ApplicationView/PasswordField";
import NumberField from "./ApplicationView/NumberField";
import DateField from "./ApplicationView/DateField";
import Heading from "./ApplicationView/Heading";
import Paragraph from "./ApplicationView/Paragraph";
import Subheading from "./ApplicationView/Subheading";
import Divider from "./ApplicationView/Divider";
import MultiSelect from "./ApplicationView/MultiSelect";
import FileInput from "./ApplicationView/FileInput";
import ProfessionalExperience from "./ApplicationView/ProfessionalExperience";
import StateCity from "./ApplicationView/StateCity";
import PhotoCapture from "./ApplicationView/PhotoCapture";
import DateTime from "./ApplicationView/DateTime";
import DeptDesg from "./ApplicationView/DeptDesg";

const GetFormComponent = ({
  cInfo,
  onBlurHandler,
  isInputFieldTouched,
  isPreview,
  element,
  key,
  defaultValue = null,
  forCandidatesOnly = true,
  value,
  approve,
  form,
  ocrDisabled,
  fillOcrData,
  errorInputs,
  getCandidateFormsList,
  tokenType,
  formType,
  getCandidateDetails,
  aiSettings,
  departments,
  formId
}) => {
  if (forCandidatesOnly) {
    if (element.fillableByCandidate === false) {
      return <Hidden data={element} key={key} />;
    }
  }
  switch (element.type) {
    case "text":
      return (
        <>
          <TextField
            onBlurHandler={onBlurHandler}
            data={element}
            isInputFieldTouched={isInputFieldTouched}
            key={key}
            defaultValue={value}
            approve={approve}
            ocrDisabled={ocrDisabled}
            errorInputs={errorInputs}
          />
        </>
      );
    case "textarea":
      return (
        <>
          <TextArea
            onBlurHandler={onBlurHandler}
            isInputFieldTouched={isInputFieldTouched}
            data={element}
            key={key}
            defaultValue={defaultValue}
            approve={approve}
            ocrDisabled={ocrDisabled}
            errorInputs={errorInputs}
          />
        </>
      );
    case "checkbox":
      return (
        <>
          <Checkbox
            onBlurHandler={onBlurHandler}
            isInputFieldTouched={isInputFieldTouched}
            data={element}
            key={key}
            defaultValue={defaultValue}
            approve={approve}
            ocrDisabled={ocrDisabled}
            errorInputs={errorInputs}
          />
        </>
      );
    case "radio":
      return (
        <Radio
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          isPreview={isPreview}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          ocrDisabled={ocrDisabled}
          errorInputs={errorInputs}
          tokenType={tokenType}
        />
      );
    case "select":
      return (
        <>
          <Select
            onBlurHandler={onBlurHandler}
            isInputFieldTouched={isInputFieldTouched}
            isPreview={isPreview}
            data={element}
            key={key}
            defaultValue={defaultValue}
            approve={approve}
            ocrDisabled={ocrDisabled}
            errorInputs={errorInputs}
            tokenType={tokenType}
          />
        </>
      );
    case "texttable":
      return (
        <TextTable
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          ocrDisabled={ocrDisabled}
          errorInputs={errorInputs}
        />
      );
    case "email":
      return (
        <>
          <EmailField
            onBlurHandler={onBlurHandler}
            isInputFieldTouched={isInputFieldTouched}
            data={element}
            key={key}
            defaultValue={defaultValue}
            approve={approve}
            ocrDisabled={ocrDisabled}
            errorInputs={errorInputs}
          />
        </>
      );
    case "number":
      return (
        <NumberField
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          ocrDisabled={ocrDisabled}
          errorInputs={errorInputs}
        />
      );
    case "multiSelect":
      return (
        <MultiSelect
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          ocrDisabled={ocrDisabled}
          errorInputs={errorInputs}
        />
      );
    case "datetime":
      return (
        <DateTime
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          ocrDisabled={ocrDisabled}
          errorInputs={errorInputs}
        />
      );
    case "file":
      return (
        <FileInput
          cInfo={cInfo}
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          form={form}
          fillOcrData={fillOcrData}
          errorInputs={errorInputs}
          getCandidateFormsList={getCandidateFormsList}
          tokenType={tokenType}
          formType={formType}
          getCandidateDetails={getCandidateDetails}
          aiSettings={aiSettings}
        />
      );
    case "date":
      return (
        <>
          <DateField
            onBlurHandler={onBlurHandler}
            isInputFieldTouched={isInputFieldTouched}
            data={element}
            key={key}
            defaultValue={defaultValue}
            approve={approve}
            ocrDisabled={ocrDisabled}
            errorInputs={errorInputs}
          />
        </>
      );
    case "password":
      return (
        <PasswordField
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          ocrDisabled={ocrDisabled}
          errorInputs={errorInputs}
        />
      );
    case "professionalexperience":
      return (
        <ProfessionalExperience
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          ocrDisabled={ocrDisabled}
          errorInputs={errorInputs}
        />
      );
    case "capturephoto":
      return (
        <PhotoCapture
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          ocrDisabled={ocrDisabled}
          errorInputs={errorInputs}
        />
      );
    case "statecity":
      return (
        <StateCity
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          ocrDisabled={ocrDisabled}
          errorInputs={errorInputs}
        />
      );
    case "departmentdesignation":
      return (
        <DeptDesg
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
          defaultValue={defaultValue}
          approve={approve}
          ocrDisabled={ocrDisabled}
          errorInputs={errorInputs}
          tokenType={tokenType}
          departments={departments}
          formId={formId}
        />
      );
    // Static
    case "subheading":
      return (
        <Subheading
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
        />
      );
    case "heading":
      return (
        <Heading
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
        />
      );
    case "divider":
      return (
        <Divider
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
        />
      );
    case "paragraph":
      return (
        <Paragraph
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
        />
      );
    case "location":
      return (
        <Location
          onBlurHandler={onBlurHandler}
          isInputFieldTouched={isInputFieldTouched}
          data={element}
          key={key}
        />
      );

    default:
      return () => <div key={key}>Unknown Type of Component</div>;
  }
};
export default GetFormComponent;
